import { useRef, useState } from "react";

export default function VideoBanner() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play().catch(() => {});
      setIsPlaying(true);
    }
  };

  return (
    <section className="bg-[#B9D0E5] py-8 md:py-12">
      <div className="container-main">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 max-w-6xl mx-auto">
          {/* Video */}
          <div className="order-0 md:order-1 w-full max-w-[240px] md:max-w-[320px]">
            <div className="relative rounded-2xl overflow-hidden bg-black border-[5px] border-white shadow-lg">
              <video
                ref={videoRef}
                src="/1.mp4"
                playsInline
                className="w-full aspect-[9/16] object-cover"
                onEnded={() => setIsPlaying(false)}
              />

              {!isPlaying && (
                <button
                  onClick={togglePlay}
                  className="absolute inset-0 flex items-center justify-center bg-black/20 hover:bg-black/30 transition-colors"
                  aria-label="تشغيل الفيديو"
                >
                  <div className="w-14 h-14 md:w-20 md:h-20 rounded-full bg-white/90 flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
                    <i className="ri-play-fill text-2xl md:text-3xl text-charcoal-900 mr-0.5" />
                  </div>
                </button>
              )}
            </div>
          </div>

          {/* Desktop Image */}
          <div className="hidden md:block md:w-1/2 relative z-10 -translate-x-[150px]">
            <img
              src="/desktop.webp"
              alt="آراءكم تهمنا"
              className="w-full h-auto object-contain"
            />
          </div>

          {/* Mobile Image */}
          <div className="block md:hidden w-full max-w-[240px] relative z-10 -mt-[70px]">
            <img
              src="/mobile.webp"
              alt="آراءكم تهمنا"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
